<template>
  <div class="PermissionSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="
              $t(
                'permission_configuration_management.common.pleaseSelectCompany'
              )
            "
            :transfer="true"
            @on-change="searchCompany"
          >
            <Option value="" selected>{{
              $t("permission_configuration_management.common.all")
            }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <!-- 选择账号 -->
      <Col span="4">
        <Select
          v-model="accountIds"
          filterable
          multiple
          :max-tag-count="1"
          :placeholder="$t('alarms.common.pleaseSelectAccount')"
          :transfer="true"
          @on-change="changeAccount(accountIds)"
        >
          <Checkbox
            v-model="singleAccount"
            @on-change="selectAllAccount"
            style="display: block;text-align:right;"
            >{{
              $t("configuration_management.customized_alarm_config.checkAll")
            }}</Checkbox
          >
          <Option :value="item.id" v-for="item in accountList" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <!--选择有问题的权限-->
      <Col span="4">
        <Select v-model="exist">
          <Option
            v-for="item in existList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </Col>
      <Button
        type="primary"
        v-hasPermission="[
          'permissionsConfigurationManagement:permission:search'
        ]"
        @click="clickExist"
        >{{ $t("alarms.common.search") }}</Button
      >
      <Button
        type="warning"
        :loading="modal_loading"
        v-hasPermission="[
          'permissionsConfigurationManagement:permission:export'
        ]"
        @click="exportAWSAccountPermissionStatistics"
        >{{ $t("common.export") }}</Button
      >
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import TablePermissions from "../permission/TablePermissions";

var tablePermissions = TablePermissions;

export default {
  name: "PermissionSearch",
  components: {},
  data() {
    return {
      modal_loading: false,
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountList: [],
      accountIds: [],
      singleAccount: false,
      permissionSearchKey: "",
      permissionSearchName: "",
      exist: "",
      existList: [
        {
          value: "false",
          label: "缺失策略"
        },
        {
          value: "all",
          label: "全部"
        }
      ]
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    } else {
      this.getAccount();
      this.companyId = this.company;
    }
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 按公司搜索
    searchCompany: function() {
      // 查询账户
      this.getAccount();
    },
    // 获取公司对应的账户下拉框
    getAccount: function() {
      // 清空数组
      this.accountList = [];
      // 清空选中的数据
      this.accountIds = [];
      // 清空复选框
      this.singleAccount = false;
      // 账号下拉框
      this.$api.account
        .queryAccountsByCompanyId(
          "companyId",
          this.companyId == null ||
            this.companyId == "" ||
            this.companyId == undefined
            ? this.company
            : this.companyId
        )
        .then(res => {
          if (res.data != null && res.data.length > 0) {
            this.accountList = res.data;
          }
        });
    },
    // 全选账号
    selectAllAccount() {
      this.accountIds = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountIds.push(item.id);
        });
      } else {
        this.accountIds = [];
      }
    },
    // 账号改变事件
    changeAccount(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    // 选择权限是否缺失
    clickExist() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountIds", this.accountIds);
      eventBus.$emit("exist", this.exist);
      tablePermissions.methods.showAll();
    },
    //导出
    exportAWSAccountPermissionStatistics: function() {
      // 获取子组件数据
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.account
        .exportAWSAccountPermissionStatistics({
          companyId: this.companyId,
          accountIds: this.accountIds,
          exist: this.exist
        })
        .then(res => {
          let fileName = "策略一览.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>
<style scoped>
.PermissionSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/permission/PermissionSearch.vue